import { h, Fragment } from 'preact';
import Config from '../../Config';
import getSitemapName from './getSitemapName';
export default function SidebarContent(props) {
    if (props.sitemap == null) {
        return (h("div", { role: "presentation", onClick: () => true }, props.children));
    }
    return (h(Fragment, null,
        h("details", { role: "navigation", "aria-label": Config.SITEMAP_LABEL, open: props.sitemap.rootPage.current ? undefined : true },
            h("summary", null, Config.SITEMAP_LABEL),
            props.sitemap.siteUrls.map((sitePage) => (h(SitemapPage, { key: sitePage.path, page: sitePage }, sitePage.current ? props.children : undefined)))),
        h("hr", null),
        h(SitemapPage, { page: props.sitemap.rootPage, dedent: true }, props.sitemap.rootPage.current ? props.children : undefined)));
}
function SitemapPage(props) {
    const title = props.page.title || getSitemapName(props.page.path);
    if (props.page.current) {
        return (h("details", { open: true, class: props.dedent ? 'left-space-fix' : 'primer-spec-toc-sitemap-item' },
            h("summary", { class: "left-space-fix primer-spec-toc-active" }, title),
            props.children));
    }
    // Wrap everything in an <a/> element to indicate to mouse-users that it's
    // a hyperlink. But don't make it focusable because the <summary/> element
    // is itself focusable. Let the <summary/> function as the true hyperlink
    // element for keyboard users and screen-readers.
    return (h("a", { href: props.page.url, tabIndex: -1 },
        h("details", { class: props.dedent ? '' : 'primer-spec-toc-sitemap-item' },
            h("summary", { role: "link", onClick: (e) => {
                    e.preventDefault();
                    window.location.href = props.page.url;
                } }, title))));
}
